import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { getPromoteFramePath } from '../../getPromoteFramePath';
import { useExperiments } from '../useExperiments';

export const useFrameSrc = (): string => {
  const { locale } = useIntl();
  const { isExperimentEnabled, getEnabledExperimentsNames } = useExperiments();
  const promoteFramePath = getPromoteFramePath();

  return useMemo(() => {
    const enabledExperiments = getEnabledExperimentsNames();

    const enabledExperimentsQuery = enabledExperiments
      ? `enabledExperiments=${enabledExperiments}`
      : '';

    const src = `${promoteFramePath}0-2`;

    const query =
      locale === 'en'
        ? enabledExperimentsQuery
          ? `?${enabledExperimentsQuery}`
          : ''
        : `?lang=${locale}${
            enabledExperimentsQuery ? `&${enabledExperimentsQuery}` : ''
          }`;

    return `${src}${query}`;
  }, [
    locale,
    isExperimentEnabled,
    getEnabledExperimentsNames(),
    promoteFramePath,
  ]);
};
